import { render, staticRenderFns } from "./AtualizacaoProcessoResumoIA.vue?vue&type=template&id=1ae52f94&scoped=true&"
import script from "./AtualizacaoProcessoResumoIA.vue?vue&type=script&lang=js&"
export * from "./AtualizacaoProcessoResumoIA.vue?vue&type=script&lang=js&"
import style0 from "./playground.styl?vue&type=style&index=0&id=1ae52f94&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae52f94",
  null
  
)

export default component.exports